export enum ManagedAccountStatus {
  Completed = "Completed",
  InProgress = "In progress",
  Archived = "Archived",
  Restore = "Restore",
}
